import React, { useEffect } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import DeedsySpinner from 'src/components/DeedsySpinner/DeedsySpinner';
import { compose } from 'recompose';
import { LO_INVITE_LINK } from 'src/features/constants';
import { pathOr } from 'ramda';
import { getPermissionByRoles } from 'src/features/RBAC/permissions';

import { getAccountRoleByUserName } from 'src/queries/advisor_profiles';
import { getNamespaceName } from 'src/services/objects/namespaces';
import { getDefaultRoute, makeRedirectURL } from './applyLink';
import { getQueryParam } from 'src/utilities/queryParams';
import {
  unAuthenticatedUser
} from 'src/utilities/storage';
import { PASSWORDLESS_ROUTE } from 'src/route_constants';
import { isNotEmpty } from 'src/utilities/hasValue';

const ApplyLanding = (props: any) => {
  const history = useHistory();
  const { match } = props;
  const campaign = getQueryParam(location.search, 'campaign');
  const who = getQueryParam(location.search, 'who');
  const renewal = getQueryParam(location.search, 'renewal');
  const productType = getQueryParam(location.search, 'loan_product_type');
  const { username, loanType } = match.params;
  const defaultRoute = getDefaultRoute(username);

  unAuthenticatedUser.campaign.set(campaign);
  unAuthenticatedUser.workflowStartedAs.set(who);
  unAuthenticatedUser.renewal.set(renewal); 

  const { isLoading: isAccountLoading, data: accounts } =
    getAccountRoleByUserName({
      username,
      object_meta: { namespace: getNamespaceName() },
    });
  const accountRoles = pathOr(
    [],
    ['advisor_profiles', 0, 'account', 'roles_id'],
    accounts
  );
  const { permissions, isLoading: isPermissionLoading }: any =
    getPermissionByRoles(accountRoles);

  useEffect(() => {
    if (!isAccountLoading && !isPermissionLoading) {
      redirectToLanding();
    }
  }, [isAccountLoading, isPermissionLoading]);

  const redirectToLanding = () => {
    const productTypeUrl = `${PASSWORDLESS_ROUTE}/${loanType}-${productType}`
    if (isNotEmpty(productType)) {
      unAuthenticatedUser.advisorUsername.set(username)
      return history.push(productTypeUrl, {
        advisorUsername: username,
        signupType: LO_INVITE_LINK,
        campaign: campaign
      });
    }
    const url = makeRedirectURL({
      permissions,
      username,
      loanType,
      defaultRoute,
    });
    history.push(url, {
      advisorUsername: username,
      signupType: LO_INVITE_LINK,
      campaign: campaign
    });
  };

  return <DeedsySpinner />;
};

export default compose(withRouter)(ApplyLanding);
